import { requiredPlan, featureLabel, currentPlan, planOf, type Feature } from "../lib/plan";

/** Shown in place of a gated feature. `full` renders a centered whole-view card. */
export function Upsell({ feature, full }: { feature: Feature; full?: boolean }) {
  const need = requiredPlan(feature);
  const have = planOf(currentPlan());
  const body = (
    <div className="card pad" style={{ borderLeft: "4px solid var(--brass)", textAlign: full ? "center" : "left", maxWidth: full ? 560 : undefined, margin: full ? "40px auto" : undefined }}>
      <div style={{ fontSize: 34, marginBottom: 6 }}>🔒</div>
      <div className="eyebrow">{need.name} plan</div>
      <h3 className="fr" style={{ color: "var(--forest)", fontSize: 22, margin: "4px 0 8px" }}>{featureLabel(feature)} is a {need.name} feature</h3>
      <p style={{ fontSize: 14, color: "#37413c", lineHeight: 1.6, marginBottom: 12 }}>
        You're on <b>{have.name}</b>. Upgrade to <b>{need.name}</b> (${need.price}/mo) to unlock it — {need.tagline.toLowerCase()}
      </p>
      <div style={{ display: "flex", gap: 8, justifyContent: full ? "center" : "flex-start", flexWrap: "wrap" }}>
        <button className="btn btn-p btn-sm" onClick={() => window.dispatchEvent(new CustomEvent("beacon-go", { detail: "admin" }))}>See plans &amp; upgrade →</button>
      </div>
      <div className="note" style={{ marginTop: 8 }}>Preview mode: change the active plan any time in <b>Admin → Billing plan</b>.</div>
    </div>
  );
  return full ? <div className="wrap">{body}</div> : body;
}
